var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"index"}},[_c('div',{staticClass:"pc"},[_c('toptab'),_c('div',{staticClass:"navbar"},[_c('navbar',{attrs:{"navbarIndex":2}}),_c('point')],1)],1),_c('div',{staticClass:"mobile"},[_c('pointm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }